<template>
  <div class="home-container">
    <!-- 顶部用户信息 -->
    <div class="header">
      <div class="user-info">
        <img v-if="profileData.avatar" :src="profileData.avatar" alt="user" class="avatar" />
        <img v-else src="@/assets/user.png" alt="user" class="avatar" />
        <div class="user-text">
          <div class="username">{{ profileData.first_name }}</div>
          <div v-if="profileData.user_type === 1" class="user-id">{{ '账户' + (currentAccount + 1) }}</div>
          <div v-if="profileData.user_type === 0 || profileData.user_type === 2" class="user-id">{{ currentAccount }}</div>
        </div>
      </div>
      <img src="../assets/change-icon.png" alt="switch" class="switch-icon" @click="showDrawer = true" />
    </div>

    <!-- 账户切换抽屉 -->
    <div class="drawer-overlay" v-if="showDrawer" @click="showDrawer = false">
      <div class="drawer" @click.stop>
        <div class="drawer-header">
          <span class="drawer-title">切换账户</span>
          <img src="../assets/close-icon.png" alt="close" class="close-icon" @click="showDrawer = false" />
        </div>
        <div class="drawer-content" v-if="profileData.user_type === 1">
          <div v-for="(item, index) in accountData" :key="index" class="account-item"
            :class="{ active: currentAccount === index }"
            @click="switchAccount(item)">
            {{ '账户' + (index + 1) }}
          </div>
        </div>
        <div class="drawer-content" v-else-if="profileData.user_type === 0 || profileData.user_type === 2">
          <div v-for="(item, index) in accountData" :key="index" class="account-item"
            :class="{ active: currentAccount === item }"
            @click="switchAccount(item)">
            {{ item }}
          </div>
        </div>
      </div>
    </div>

    <!-- 资产卡片 -->
    <div class="asset-card">
      <div class="asset-top">
        <div class="asset-header">
          <div class="asset-amount">{{ balanceOverviewData.money }}</div>
          <div class="asset-label">
            <span>总资产</span>
            <img src="../assets/prompt-icon.png" alt="prompt" class="prompt-icon" />
          </div>
        </div>
        <div class="currency-tag">{{ balanceOverviewData.coin }}</div>
      </div>

      <div class="asset-bottom">
        <div class="asset-details">
          <div class="detail-item">
            <img src="../assets/money-icon.png" alt="money" class="detail-icon" />
            <div class="detail-text">
              <div class="detail-value">{{ balanceOverviewData.init_balance }}</div>
              <div class="detail-label">本金</div>
            </div>
          </div>
          <div class="asset-line"></div>
          <div class="detail-item">
            <img src="../assets/profit-icon.png" alt="profit" class="detail-icon" />
            <div class="detail-text">
              <div class="detail-value">{{ balanceOverviewData.profit }}</div>
              <div class="detail-label">累计收益</div>
            </div>
          </div>
        </div>
        <div class="asset-tip">
          <span>总成本总收益信息根据托管下行交易记录计算，仅供参考</span>
        </div>
      </div>
    </div>

    <!-- 最新月报 -->
    <div class="monthly-report-section" v-if="monthlyReportData.name" @click="openMonthlyReport">
      <div class="report-header">
        <span class="report-title">近期月报</span>
        <img src="../assets/right-icon.png" alt="arrow" class="arrow-icon" />
      </div>
    </div>

    <!-- 收益图表 -->
    <div class="chart-section">
      <div class="section-header">
        <span class="section-title">收益图表</span>
      </div>

      <div class="chart-container">
        <div ref="lineChart1" class="echarts-chart"></div>
      </div>

      <div class="chart-container">
        <div ref="barChart" class="echarts-chart"></div>
      </div>

      <div class="chart-container">
        <div ref="lineChart2" class="echarts-chart"></div>
      </div>
    </div>

    <div class="data-tabs">
      <div class="tab" :class="{ active: activeTab === 'order' }" @click="activeTab = 'order'">近期净值</div>
      <div class="data-line"></div>
      <div class="tab" :class="{ active: activeTab === 'history' }" @click="activeTab = 'history'">历史表现</div>
    </div>

    <!-- 数据列表-->
    <div class="data-section" v-if="activeTab === 'order'">
      <div class="data-table">
        <div class="table-header">
          <span>日期</span>
          <span>累计净值</span>
          <span>变动</span>
        </div>
        <div class="table-row" v-for="(item, index) in orderData" :key="index">
          <span>{{ item.create_date }}</span>
          <span>{{ item.total_balance }}</span>
          <span class="positive">{{ item.money > 0 ? '+' : '' }}{{ item.money }}</span>
        </div>
      </div>
    </div>

    <!-- 历史查询 -->
    <div class="data-section" v-if="activeTab === 'history'">
      <div class="data-table">
        <div class="table-header" style="grid-template-columns: 1fr 1fr;">
          <span>指标</span>
          <span>数值</span>
        </div>
        <div class="table-row" style="grid-template-columns: 1fr 1fr;" v-for="(item, index) in histPerfData"
          :key="index">
          <span>{{ item.performance_name }}</span>
          <span class="positive">{{ item.performance_value }}</span>
        </div>
      </div>
    </div>

    <!-- 底部导航 -->
    <BottomNav />
  </div>
</template>

<script>
import BottomNav from '@/components/BottomNav.vue';
import { systemBalanceOverview, systemProfile, systemNetWorthCurve, systemHistPerf, systemAssetBarChart, systemPriceCurve, systemMonthlyReport } from '../api/apiList/system';
import * as echarts from 'echarts';

export default {
  name: 'Home',
  components: {
    BottomNav
  },
  data() {
    return {
      showDrawer: false,
      currentAccount: '',
      activeTab: 'order', 
      accountData: [],
      profileData: {
        avatar: '',
        bind_name: '',
        date_joined: '',
        first_name: '',
        id: '',
        name: '',
        phone: '',
        user_type: '',
        username: ''
      },
      balanceOverviewData: {
        coin: '',
        init_balance: '',
        money: '',
        name: '',
        profit: '',
        profit_percentage: ''
      },
      netWorthCurveData: [],
      orderData: [],
      assetBarChartData: [],
      priceCurveData: [],
      histPerfData: [],
      monthlyReportData: {
        name: '',
        url: ''
      },
      chart1: null,
      chart2: null,
      chart3: null
    };
  },
  mounted() {
    this.getProfile()
  },
  beforeDestroy() {
    if (this.chart1) this.chart1.dispose();
    if (this.chart2) this.chart2.dispose();
    if (this.chart3) this.chart3.dispose();
  },
  methods: {
    async getProfile() {
      let info = null
      if (this.accountData && this.accountData.length > 0) {
        info = await systemProfile({
          name: this.profileData.user_type === 1 ? this.accountData[this.currentAccount] : this.currentAccount
        })
      } else {
        info = await systemProfile()
      }
      this.profileData = info
      if (this.profileData.avatar) {
        this.profileData.avatar = 'data:image/png;base64,' + this.profileData.avatar
      }
      localStorage.setItem('profileData', JSON.stringify(info))
      if (info.bind_name) {
        this.accountData = info.bind_name.includes(',') ? info.bind_name.split(',') : [info.bind_name]
        if (this.profileData.user_type === 1) {
          this.currentAccount = info.name ? this.accountData.findIndex(item => item === info.name) : 0
        } 
        else if (this.profileData.user_type === 0 || this.profileData.user_type === 2) {
          this.currentAccount = info.name ? info.name : this.accountData[0]
        }
      }
      if(info.name === '' || info.name === null){
        return this.getProfile()
      }
      this.getBalanceOverview()
      this.getNetWorthCurve()
      this.getAssetBarChart()
      this.getPriceCurve()
      this.getHistPerf()
      this.getMonthlyReport()
    },
    async getBalanceOverview() {
      let info = await systemBalanceOverview()
      this.balanceOverviewData = info
    },
    async getNetWorthCurve() {
      let info = await systemNetWorthCurve()
      this.netWorthCurveData = info.create_date.map((item, index) => {
        return {
          create_date: item,
          money: info.money[index],
          total_balance: info.total_balance[index]
        }
      })
      this.orderData = Object.assign([], this.netWorthCurveData)
      this.orderData.reverse()
      this.$nextTick(() => {
        this.initLineChart1();
      });
    },
    async getAssetBarChart() {
      let info = await systemAssetBarChart()
      this.assetBarChartData = info.create_date.map((item, index) => {
        return {
          create_date: item,
          money: info.money[index]
        }
      })
      this.$nextTick(() => {
        this.initBarChart();
      });
    },
    async getPriceCurve() {
      let info = await systemPriceCurve()
      this.priceCurveData = info.create_date.map((item, index) => {
        return {
          create_date: item,
          price: info.price[index]
        }
      })
      this.$nextTick(() => {
        this.initLineChart2();
      });
    },
    async getHistPerf() {
      let info = await systemHistPerf()
      this.histPerfData = info.data
    },
    async getMonthlyReport(){
      let info = await systemMonthlyReport()
      if (info && info.data && info.data.length > 0) {
        this.monthlyReportData = {
          name: info.data[0].name,
          url: info.data[0].url
        }
      }
    },
    openMonthlyReport() {
      this.$router.push('/report');
    },
    switchAccount(item) {
      if (this.profileData.user_type === 1) {
        this.currentAccount = this.accountData.findIndex(account => account === item)
      } else if (this.profileData.user_type === 0 || this.profileData.user_type === 2) {
        this.currentAccount = item;
      }
      this.getProfile()
      this.showDrawer = false;
    },
    initLineChart1() {
      if (this.chart1) {
        this.chart1.dispose();
      }
      this.chart1 = echarts.init(this.$refs.lineChart1);

      const dates = this.netWorthCurveData.map(item => item.create_date);
      const values = this.netWorthCurveData.map(item => parseFloat(item.money));

      const dataLength = values.length;
      let labelInterval = Math.max(1, Math.floor(dataLength / 5));

      const option = {
        backgroundColor: 'transparent',
        legend: {
          data: ['收益率'],
          right: '5%',
          top: '0%',
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
        },
        grid: {
          left: '0%',
          right: '0%',
          top: '20%',
          bottom: '15%',
          containLabel: true
        },
        dataZoom: [
          {
            type: 'inside',
            zoomOnMouseWheel: true,
            moveOnMouseMove: true,
            moveOnMouseWheel: true
          }
        ],
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#36D8AF',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          formatter: (params) => {
            const param = params[0];
            return `${param.name}<br/>收益率: ${param.value}%`;
          }
        },
        xAxis: {
          type: 'category',
          data: dates,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#666',
            fontSize: 10
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#2a2a2a',
              type: 'dashed'
            }
          },
          axisLabel: {
            color: '#666',
            fontSize: 10
          }
        },
        series: [
          {
            name: '收益率',
            type: 'line',
            data: values,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            // showSymbol: false,
            lineStyle: {
              color: '#36D8AF',
              width: 2
            },
            itemStyle: {
              color: '#36D8AF',
              borderColor: '#fff',
              borderWidth: 0
            },
            emphasis: {
              scale: true,
              itemStyle: {
                color: '#36D8AF',
                borderColor: '#fff',
                borderWidth: 3,
                shadowBlur: 10,
                shadowColor: '#36D8AF'
              }
            },
            label: {
              show: true,
              position: 'top',
              color: '#666',
              fontSize: 10,
              formatter: (params) => {
                if (params.dataIndex % labelInterval === 0 || params.dataIndex === dataLength - 1) {
                  return params.value + '%';
                }
                return '';
              }
            }
          }
        ]
      };

      this.chart1.setOption(option);
    },
    initBarChart() {
      if (this.chart2) {
        this.chart2.dispose();
      }
      this.chart2 = echarts.init(this.$refs.barChart);

      const dates = this.assetBarChartData.map(item => item.create_date);
      const values = this.assetBarChartData.map(item => parseFloat(item.money));

      const dataLength = values.length;
      let labelInterval = Math.max(1, Math.floor(dataLength / 5));

      const option = {
        backgroundColor: 'transparent',
        legend: {
          data: ['资产变化'],
          right: '5%',
          top: '0%',
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
        },
        grid: {
          left: '0%',
          right: '0%',
          top: '20%',
          bottom: '15%',
          containLabel: true
        },
        dataZoom: [
          {
            type: 'inside',
            zoomOnMouseWheel: true,
            moveOnMouseMove: true,
            moveOnMouseWheel: true
          }
        ],
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#36D8AF',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            const param = params[0];
            return `${param.name}<br/>资产变化: ${param.value}`;
          }
        },
        xAxis: {
          type: 'category',
          data: dates,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#666',
            fontSize: 10
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#2a2a2a',
              type: 'dashed'
            }
          },
          axisLabel: {
            color: '#666',
            fontSize: 10
          }
        },
        series: [
          {
            name: '资产变化',
            type: 'bar',
            data: values,
            barWidth: '30%',
            itemStyle: {
              color: '#36D8AF',
              borderRadius: [4, 4, 0, 0]
            },
            emphasis: {
              itemStyle: {
                color: '#2EF5C1',
                shadowBlur: 10,
                shadowColor: '#36D8AF'
              }
            },
            label: {
              show: true,
              position: 'top',
              color: '#666',
              fontSize: 10,
              formatter: (params) => {
                if (params.dataIndex % labelInterval === 0 || params.dataIndex === dataLength - 1) {
                  return params.value;
                }
                return '';
              }
            }
          }
        ]
      };

      this.chart2.setOption(option);
    },
    initLineChart2() {
      if (this.chart3) {
        this.chart3.dispose();
      }
      this.chart3 = echarts.init(this.$refs.lineChart2);

      const dates = this.priceCurveData.map(item => item.create_date);
      const values = this.priceCurveData.map(item => parseFloat(item.price));

      const dataLength = values.length;
      let labelInterval = Math.max(1, Math.floor(dataLength / 5));

      const minValue = Math.min(...values);
      const maxValue = Math.max(...values);
      const range = maxValue - minValue;
      const yMin = Math.floor(minValue - range * 0.1);
      const yMax = Math.ceil(maxValue + range * 0.1);

      const option = {
        backgroundColor: 'transparent',
        legend: {
          data: ['行情曲线'],
          right: '5%',
          top: '0%',
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
        },
        grid: {
          left: '0%',
          right: '0%',
          top: '20%',
          bottom: '0%',
          containLabel: true
        },
        dataZoom: [
          {
            type: 'inside',
            zoomOnMouseWheel: true,
            moveOnMouseMove: true,
            moveOnMouseWheel: true
          }
        ],
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#36D8AF',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          formatter: (params) => {
            const param = params[0];
            return `${param.name}<br/>行情曲线: ${param.value}`;
          }
        },
        xAxis: {
          type: 'category',
          data: dates,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#666',
            fontSize: 10
          }
        },
        yAxis: {
          type: 'value',
          min: yMin,
          max: yMax,
          splitLine: {
            lineStyle: {
              color: '#2a2a2a',
              type: 'dashed'
            }
          },
          axisLabel: {
            color: '#666',
            fontSize: 10
          }
        },
        series: [
          {
            name: '行情曲线',
            type: 'line',
            data: values,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            // showSymbol: false,
            lineStyle: {
              color: '#36D8AF',
              width: 2
            },
            itemStyle: {
              color: '#36D8AF',
              borderColor: '#fff',
              borderWidth: 0
            },
            emphasis: {
              scale: true,
              itemStyle: {
                color: '#36D8AF',
                borderColor: '#fff',
                borderWidth: 3,
                shadowBlur: 10,
                shadowColor: '#36D8AF'
              }
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(54, 216, 175, 0.4)' },
                  { offset: 1, color: 'rgba(54, 216, 175, 0.1)' }
                ]
              }
            },
            label: {
              show: true,
              position: 'top',
              color: '#666',
              fontSize: 10,
              formatter: (params) => {
                if (params.dataIndex % labelInterval === 0 || params.dataIndex === dataLength - 1) {
                  return params.value;
                }
                return '';
              }
            }
          }
        ]
      };

      this.chart3.setOption(option);
    },
  }
};
</script>

<style scoped>
.home-container {
  width: 100%;
  min-height: 100vh;
  background-color: #000;
  color: #fff;
  padding: 20px 20px 80px;
  overflow: auto;
}

/* 顶部用户信息 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.user-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.username {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.user-id {
  font-size: 12px;
  color: #999;
}

.switch-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

/* 抽屉遮罩 */
.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* 抽屉 */
.drawer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 60%;
  background-color: #1a1a1a;
  animation: slideLeft 0.3s ease;
}

@keyframes slideLeft {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #2a2a2a;
}

.drawer-title {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.close-icon {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.drawer-content {
  padding: 10px;
}

.account-item {
  padding: 16px 20px;
  margin-bottom: 12px;
  border-radius: 8px;
  font-size: 15px;
  color: #999;
  cursor: pointer;
  transition: all 0.3s ease;
}

.account-item:hover {
  background-color: #333;
}

.account-item.active {
  background-color: #36D8AF;
  color: #000;
  font-weight: 500;
}

/* 资产卡片 */
.asset-card {
  margin-bottom: 10px;
  background-image: url('@/assets/profit-card-bg.png');
  background-size: 100% 100%;
  border-radius: 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.asset-top {
  width: 100%;
  height: 90px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.asset-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}

.asset-amount {
  font-size: 24px;
  font-weight: 600;
  color: #000;
}

.currency-tag {
  background-color: #000;
  color: #fff;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.asset-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}

.asset-bottom {
  width: 100%;
  height: 110px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.asset-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
}

.asset-line {
  height: 100%;
  width: 1px;
  background-color: rgba(255, 255, 255, 0.2);
  margin: 0 20px;
}

.detail-item {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 10px;
}

.detail-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
}

.detail-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-value {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.detail-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.asset-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.5);
}

.asset-tip span {
  color: #757B8C;
}

.prompt-icon {
  width: 14px;
  height: 14px;
}

/* 最新月报 */
.monthly-report-section {
  margin-bottom: 10px;
  padding: 15px 20px;
  background-color: #191919;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.monthly-report-section:hover {
  background-color: #222;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.report-title {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.arrow-icon {
  width: 16px;
  height: 16px;
}

.report-name {
  font-size: 14px;
  color: #36D8AF;
  font-weight: 400;
}

/* 收益图表 */
.chart-section {
  padding: 20px;
  background-color: #191919;
  border-radius: 16px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.section-action {
  font-size: 14px;
  color: #36D8AF;
  cursor: pointer;
}

.chart-container {
  margin-bottom: 10px;
  position: relative;
}

.chart-title {
  font-size: 14px;
  color: #fff;
  margin-bottom: 15px;
  font-weight: 500;
}

.echarts-chart {
  width: 100%;
  height: 240px;
}

/* 数据列表 */
.data-section {
  padding: 0;
  background-color: transparent;
  border-radius: 16px;
  overflow: hidden;
}

.data-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
}

.data-line {
  height: 15px;
  width: 1px;
  background-color: rgba(255, 255, 255, 0.2);
}

.tab {
  flex: 1;
  display: block;
  font-size: 16px;
  color: #999;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}

.tab.active {
  color: #36D8AF;
  font-weight: 500;
}

.tab-divider {
  color: #333;
}

.data-table {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-height: 350px;
  overflow: auto;
  position: relative;
}

.table-header,
.table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  font-size: 14px;
  padding: 20px 20px;
  text-align: center;
}

.table-header {
  color: #999;
  background-color: #1B1B1B;
  font-weight: 400;
  position: sticky;
  top: 0;
}

.table-header span {
  color: #999;
}

.table-row {
  color: #8a8a8a;
  background-color: #1B1B1B;
}

.table-row:nth-child(even) {
  background-color: #1a3a35;
}

.table-row span {
  color: #8a8a8a;
}

.table-row .positive {
  color: #36D8AF;
  font-weight: 400;
}
</style>
